var _desc, _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "carbon:checkmark-outline",
    rx: 0,
    width: 23,
    height: 23,
    transform: "translate(0.500000 0.500000)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 16.06L6.75 12.3L7.8 11.25L10.5 13.93L16.18 8.25L17.25 9.31L10.5 16.06Z",
    fill: "#56BD74",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 1.5C9.92 1.5 7.89 2.11 6.16 3.26C4.43 4.42 3.09 6.06 2.29 7.98C1.5 9.9 1.29 12.01 1.7 14.04C2.1 16.08 3.1 17.95 4.57 19.42C6.04 20.89 7.91 21.89 9.95 22.29C11.98 22.7 14.09 22.49 16.01 21.7C17.93 20.9 19.57 19.56 20.73 17.83C21.88 16.1 22.5 14.07 22.5 12C22.5 9.21 21.39 6.54 19.42 4.57C17.45 2.6 14.78 1.5 12 1.5ZM12 21C10.22 21 8.47 20.47 7 19.48C5.52 18.49 4.36 17.08 3.68 15.44C3 13.79 2.82 11.99 3.17 10.24C3.52 8.49 4.37 6.89 5.63 5.63C6.89 4.37 8.49 3.52 10.24 3.17C11.99 2.82 13.79 3 15.44 3.68C17.08 4.36 18.49 5.51 19.48 7C20.47 8.47 21 10.21 21 12C21 14.38 20.05 16.67 18.36 18.36C16.67 20.05 14.38 21 12 21Z",
    fill: "#56BD74",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checkedIcon.00f02770d071e84b567eec9376b5a8a0.svg";
export { ForwardRef as ReactComponent };